<script setup lang="ts">
import { type PropType } from 'vue'
import type { IMercariProductDetail } from '@/types/Mercari'
import BaseSellerCard from '@/components/ui/sellerCard/BaseSellerCard.vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

const props = defineProps({
	pageContent: {
		type: Object as PropType<{
			[key: string]: string
		}>,
		required: true,
	},
	sellerInfo: {
		type: Object as PropType<IMercariProductDetail['sellerInfo']>,
		required: true,
	},
})

const handleSellerClick = () => {
	if (!props.sellerInfo) return

	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.MercariDetail,
		button_name: 'View on Merchant Site',
	})

	window.open(props.sellerInfo.infoUrl, '_blank')
}
</script>

<template>
	<div class="mt-48px mdp:mt-casual-friends">
		<h5 class="typography-h5-str text-n-950">
			{{ pageContent.detail_seller_title }}
		</h5>
		<div class="mt-24px mdp:mt-good-friends">
			<BaseSellerCard
				v-if="sellerInfo"
				:avatar="sellerInfo.avatar"
				:name="sellerInfo.name"
				:ratingNumber="sellerInfo.ratingNumber"
				:starRatingScore="sellerInfo.starRatingScore"
				:isVerified="sellerInfo.verified"
				:verifiedText="pageContent.detail_verified_seller"
				:unverifiedText="pageContent.detail_unverified_seller"
				:buttonText="pageContent.detail_button_view_on_mercari"
				@click="handleSellerClick"
			/>
		</div>
	</div>
</template>
